import React from "react";
import Container from "react-bootstrap/Container";


const Home = (props) => {

  return (
    <Container>
        <div className="pt-5 d-flex justify-content-center">
          <h2>Ampers & Ampersand</h2>
        </div>
        <div className="d-flex justify-content-center">
          <h5>Licensed Handyman and Contractor Services</h5>
        </div>
    </Container>
  )
}

export default Home